import {
	getRoom,
	getRooms,
	getRoomsSearchFilter,
	patchRoom,
	RoomSearchFilterParam,
} from '../../api/rooms';
import { Room, RoomParams } from '../../interfaces/api/room';

export async function fetchRooms(): Promise<Room[]> {
	try {
		return await getRooms();
	} catch (error) {
		throw error;
	}
}

export async function fetchRoom(id: number): Promise<Room> {
	try {
		return await getRoom(id);
	} catch (error) {
		throw error;
	}
}

export async function fetchRoomsSearchFilter(params: RoomSearchFilterParam): Promise<Room[]> {
	try {
		return await getRoomsSearchFilter(params);
	} catch (error) {
		throw error;
	}
}

export async function updateRoom(id: number, params: RoomParams): Promise<Room> {
	try {
		return await patchRoom(id, params);
	} catch (error) {
		throw error;
	}
}
